/*
 * Copyright (c) 2025. Saddhu
 * Project: shopify-impulse
 * File: micas_return.js
 * Date: 2025/3/26 11:55
 * Author: Saddhu
 */

const returnAPIHost = 'https://service.themicas.com/api/oms'
function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function(...args) {
    const context = this;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}
class MicasReturnStars {
  constructor({wrapper}) {
    this.wrapper = wrapper
    this.submitApi = `${returnAPIHost}/oversea/get/orderAndEmail`
    this.emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    this.itemsUrl = 'return_items.html'
    this.init()
  }
  init(){
    this.form = {
      order: null,
      email: null,
    }
    this.id=null;
    this.formError = false
    this.getEl();
    this.bindEvent()
    const params = new URLSearchParams(window.location.search);
    const order = params.get('order');
    const email = params.get('email');
    if (order && email) {
      this.orderInput.value = order
      this.emailInput.value = email
      this.form.order = order
      this.form.email = email
      this.submitBtn.click()
    }
  }
  getEl() {
    this.orderInput = this.wrapper.querySelector('.js-order-input')
    this.emailInput = this.wrapper.querySelector('.js-email-input')
    this.submitBtn = this.wrapper.querySelector('.js-submit-btn')
    this.errorTips = this.wrapper.querySelector('.js-error-tips')
    this.selectorOptions = this.wrapper.querySelector('.js-selector-options')
    this.selectorItemList = this.wrapper.querySelectorAll('.js-selector-item')
    this.selectorInputList = this.wrapper.querySelectorAll('.js-selector-input')
  }
  bindEvent(){
    this.orderBindEvent()
    this.emailBindEvent()
    this.submitBindEvent()
    this.selectorOptionsBindEvent()
  }
  orderBindEvent() {
    this.orderInput.addEventListener('input', (ev) => {
      this.clearError()
      this.clearSelectorOptions()
      this.form.order = ev.target.value.trim()
    })
  }
  emailBindEvent() {
    this.emailInput.addEventListener('input', (ev) => {
      this.clearError()
      this.clearSelectorOptions()
      this.form.email = ev.target.value.trim();
    })
    this.emailInput.addEventListener('change', (ev) => {
      const value = ev.target.value.trim();
      if (!this.emailRegex.test(value)) {
        this.submitError("The mailbox number format is incorrect, please re-enter")
      }
    })
  }
  submitBindEvent() {
    this.submitBtn.addEventListener('click', async () => {
      if(!this.form.order || !this.form.email){
        this.submitError('Please fill in your order number and email')
        return
      }
      try {
        const res = await this._submit()
        if (res.code === 200){
          this.submitSuccess(res.data)
        }else {
          this.submitBtn.classList.remove('start-loading');
          this.submitBtn.disabled = false;
          const isChinese = /[\u4e00-\u9fa5]/;
          if (isChinese.test(res.msg)){
            this.submitError('Abnormal Error, Please Try Again.')
          } else {
            this.submitError(res.msg)
          }

        }
      } catch (e) {
        this.submitBtn.classList.remove('start-loading');
        this.submitBtn.disabled = false;
        this.submitError('Abnormal Error, Please Try Again.')
        console.log(e)
      }
    })
  }
  selectorOptionsBindEvent() {
    this.selectorInputList.forEach(selectorInput => {
      selectorInput.addEventListener('change', ev=>{
        const checked = ev.target.checked
        const type = ev.target.value
        if (checked){
          this.goNextPage(type)
        }
      })
    })
  }
  _submit(){
    this.submitBtn.classList.add('start-loading');
    this.submitBtn.disabled = true;
    let order = this.form.order
    if (order.charAt(0) === '#') {
      order = order.substring(1);
    }
    const reqData = {
      email:  this.form.email,
      number: order
    }
    return fetch(this.submitApi, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(reqData)
    }).then(res => res.json())
  }
  submitSuccess(data){
    const typeList  = data.typeList;
    this.data =  data;
    if (typeList.length === 1){
      this.goNextPage(typeList[0])
    }else {
      this.submitBtn.classList.remove('start-loading');
      this.submitBtn.disabled = false;
      this.showSelectorOptions(typeList)
    }
  }
  submitError(msg){
    this.formError = true
    this.errorTips.innerHTML = msg
    this.wrapper.classList.add('form-error');
    this.submitBtn.classList.add('start-error')
  }
  clearError(){
    if (!this.formError){return}
    this.formError = false
    this.errorTips.innerHTML = ''
    this.wrapper.classList.remove('form-error');
    this.submitBtn.classList.remove('start-error')
  }
  showSelectorOptions (typeList) {
    this.selectorItemList.forEach(selectorItem => {
      const selectorItemType = selectorItem.dataset.type * 1;
      if (typeList.includes(selectorItemType)){
        selectorItem.classList.remove('hide')
      }else {
        selectorItem.classList.add('hide')
      }
    })
    this.selectorOptions.classList.remove('hide');
    this.submitBtn.classList.add('start-wait')
  }
  clearSelectorOptions() {
    if (!this.id) {return}
    this.id=null;
    this.submitBtn.disabled = false;
    this.submitBtn.classList.remove('start-loading')
    this.submitBtn.classList.remove('start-wait')
    this.selectorOptions.classList.add('hide');
    this.selectorItemList.forEach(selectorItem => {
      selectorItem.classList.add('hide')
    })
    this.selectorInputList.forEach(selectorInput => {
      selectorInput.checked = false;
    })
  }
  goNextPage (type){
    window.location.href = `${this.itemsUrl}?type=${type}&number=${this.data.number}&email=${this.data.email}`;
  }
}
class MicasReturnItems {
  constructor( { wrapper } ) {
    this.wrapper = wrapper
    this.getApi = `${returnAPIHost}/oversea/get/order/status`
    this.getReasonApi = `${returnAPIHost}/oversea/get/config/v2`
    const params = new URLSearchParams(window.location.search);
    this.typeStr = params.get('type');
    this.numberStr = params.get('number');
    this.emailStr = params.get('email');
    this.init().then()
  }
  async init() {
    this.initTemplate();
    try {
      const [res, reason] = await Promise.all([
        this._getData(),
        this._getReason()
      ]);
      if (res.code === 200 && reason.code === 200){
        this.reasonFlatList = this._formatReason(reason.data);
        this.reasonData = this._arrayToTree(this.reasonFlatList)
        this.data = res.data;
        this.render()
      }else {
        console.log(res.message)
      }
    } catch (e) {
      console.log(e)
    }
  }
  initTemplate() {
    const template = this.wrapper.querySelector('.js-order-item');
    const templatePcList = template.querySelectorAll('.js-template-pc')
    const templateMobileList = template.querySelectorAll('.js-template-mobile')
    if (window.matchMedia('(max-width: 768px)').matches){
      templatePcList.forEach(item => item.remove())
    }else {
      templateMobileList.forEach(item => item.remove())
    }
    this.template = template.cloneNode(true);
    this.template.classList.remove('hide')
    template.remove();
  }
  creatTemplate(returnId) {
    const template = this.template.cloneNode(false);
    const innerHTML = this.template.innerHTML
    template.innerHTML = innerHTML.replaceAll("#{return_id}", returnId)
    return template
  }
  _getData() {
    return fetch(this.getApi, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        number: this.numberStr,
        email: this.emailStr,
        type: this.typeStr
      })
    }).then(res => res.json())
  }
  _getReason() {
    return fetch(this.getReasonApi, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
  }
  _formatData(data, index) {
    const formatData = {}
    formatData.email = data.email;
    formatData.number = data.number;
    formatData.id = data.id || index
    formatData.orderId = data.orderId
    formatData.order = data.number
    formatData.requisition = data.orderNo
    formatData.logistics = data.trackingNumber
    formatData.notes = data.remark
    formatData.images = data.problemPhotoList || []
    formatData.details = data.skuList.map(skuItem => {
      let returnReasonEn =  skuItem?.returnReasonEn || ''
      if((skuItem.returnReason * 1) < 999) {
        // 新版级联选择
        const reasonInfo = this.reasonFlatList.find(item => item.id == skuItem.returnReason)
        if (reasonInfo) {
          const value = reasonInfo?.automaticName || '';
          returnReasonEn = reasonInfo?.parentAutomaticName ? `${reasonInfo.parentAutomaticName} / ${value}` : value;
        }
      }
      return {
        id: skuItem.orderSkuOriginalId,
        picture: skuItem.url,
        title: skuItem.title,
        attribute: skuItem.attribute,
        price: (skuItem.price * 1).toFixed(2),
        discount: (skuItem.discountPrice * 1).toFixed(2),
        quantity: skuItem.quantity,
        reason: skuItem.returnReason,
        returnReasonEn: returnReasonEn,
        notEligible: skuItem.notEligible,
      }
    })
    //订单号
    formatData.orderNumber = data.orderNumber
    //交易号
    formatData.transactionNumber = data.number;
    //物流单号
    formatData.logisticsNumber = data.logisticsNumber
    //退货单号
    formatData.orderNo = data.orderNo
    return formatData;
  }
  _formatReason(data) {
    return data?.map((item) => {
      if (item.parentId === "0") {
        return { ...item, parentAutomaticName: ''}
      }
      const parent = data.find(parent => parent.id === item.parentId) || {};
      return { ...item, parentAutomaticName: parent?.automaticName || ''}
    }) || []
  }
  _arrayToTree(data) {
    return data?.reduce((tree, item) => {
      if (item.parentId === "0") {
        tree.push({ ...item, children: []});
      } else {
        const parent = tree.find(parent => parent.id === item.parentId);
        if (parent) {
          parent.children.push({ ...item});
        }
      }
      return tree;
    }, []) || []
  }
  render(){
    const type = this.typeStr * 1
    const fragment = document.createDocumentFragment()
    this.data.forEach((data, index) => {
      const formattedData = this._formatData(data, index)
      const returnId = formattedData.id;
      const wrapper = this.creatTemplate(returnId);
      new MicasReturnItem({type, data:formattedData, reasonData: this.reasonData, reasonFlatList: this.reasonFlatList, wrapper})
      fragment.appendChild(wrapper)
    })
    this.wrapper.classList.remove('rend-loading')
    this.wrapper.appendChild(fragment)
  }
}
class MicasReturnItem {
  constructor( { type, data, reasonData, reasonFlatList, wrapper }) {
    this.type = type
    this.data = data
    this.reasonData = reasonData || []
    this.reasonFlatList = reasonFlatList || []
    this.wrapper = wrapper
    this.starsUrl = 'return_start.html'
    this.submitApi = `${returnAPIHost}/oversea/create`
    this.submitLogisticsApi = `${returnAPIHost}/oversea/updateReturning`
    this.requireImageReasonList = reasonFlatList.filter(item => item?.imgType === 1)?.map(i => i.id) || [];
    this.init()
  }
  init(){
    this.form={
      email: this.data.email,
      number: this.data.number,
      id: this.data.id,
      orderId: this.data.orderId,
      logistics: null,
      details: [],
      images: [],
      notes: null,
    }
    this.formatData()
    this.data.details.forEach(detail => {
      if (!detail.notEligible) {
        const checked = this.type !== 1
        this.form.details.push({
          id: detail.id,
          checked: checked,
          quantity: detail.quantity,
          price: detail.price,
          reason: null,
          notEligible: detail.notEligible
        })
      }
    })
    this.getEl();
    this.getElTemplate();
    if (this.type === 1){
      this.initCreat()
    } else if (this.type === 2){
      this.initTracking()
    }else if (this.type === 3){
      this.initStatus()
    }else {
      console.log('类型错误', this.type)
    }
    this.checkSubmit()
  }
  getEl() {
    this.orderNumberEl = this.wrapper.querySelector('.js-order-number');
    this.requisitionNumberEl = this.wrapper.querySelector('.js-requisition-number');
    this.logisticsNumberWrapper = this.wrapper.querySelector('.js-logistics-number-wrapper');
    this.logisticsNumberEl = this.wrapper.querySelector('.js-logistics-number');
    this.logisticsNumbeeErorTipsrEl = this.wrapper.querySelector('.logistics-number-error-tips-js');
    this.detailList = this.wrapper.querySelector('.js-details-list');
    this.rowAllRadio = this.wrapper.querySelector('.js-row-all');
    this.detailsTotalElList = this.wrapper.querySelectorAll('.js-details-total');
    this.detailsQuantityTotalEl = this.wrapper.querySelector('.js-quantity-total');
    this.imageWrapper = this.wrapper.querySelector('.js-image-wrapper');
    this.imageUpload = this.wrapper.querySelector('.js-image-upload');
    this.notesEl = this.wrapper.querySelector('.js-notes');
    this.notesTextEl = this.wrapper.querySelector('.js-notes-text');
    this.notesLengthEl = this.wrapper.querySelector('.js-notes-length');
    this.explainEl = this.wrapper.querySelector('.js-explain');
    this.submitWrapper = this.wrapper.querySelector('.js-submit-wrapper');
    this.cancelBtn = this.wrapper.querySelector('.js-btn-cancel');
    this.submitBtn = this.wrapper.querySelector('.js-btn-submit');
    this.imagesTitleEl = this.wrapper.querySelector('.js-images-title');
  }
  getElTemplate(){
    const imageTemplate = this.imageWrapper.querySelector('.js-template');
    this.imageTemplate = imageTemplate.cloneNode(true);
    this.imageTemplate.classList.remove('js-template');
    imageTemplate.remove();
    const detailListTemplate = this.detailList.querySelector('.js-template')
    this.detailListTemplate = detailListTemplate.cloneNode(true);
    this.detailListTemplate.classList.remove('js-template');
    detailListTemplate.remove();

    // 插入退货原因html
    const reasonOptionsEl = this.detailListTemplate.querySelector('.js-reason-options');
    const reasonTemplateEl = this.detailListTemplate.querySelector('.js-template-reason');
    const reasonChildrenTemplateEl = this.detailListTemplate.querySelector('.js-template-reason-children');
    if (reasonTemplateEl){
      const reasonChildrenTemplate = reasonChildrenTemplateEl.cloneNode(true);
      reasonChildrenTemplate.classList.remove('js-template-reason-children');
      reasonChildrenTemplateEl.remove();

      const reasonTemplate = reasonTemplateEl.cloneNode(true);
      reasonTemplate.classList.remove('js-template-reason');
      reasonTemplateEl.remove();

      const fragment = document.createDocumentFragment()
      // 循环原因列表 插入原因项模版
      this.reasonData.forEach(reason => {
        const reasonLi = this.creatDivFromTemplate(reasonTemplate, {
          return_id:this.data.orderId,
          reason_id: reason.id,
          reason_name: reason.automaticName,
        });
        reasonLi.dataset.id = reason.id
        const reasonChildrenOptionsEl = reasonLi.querySelector('.js-reason-children-options')

        // 如果有二级, 则循环插入二级,同时禁用1级
        if(reason?.children?.length) {
          const reasonOptionInput = reasonLi.querySelector('input')
          reasonOptionInput.disabled=true;
          reason.children.forEach(childrenReason => {
            const reasonChildrenLi = this.creatDivFromTemplate(reasonChildrenTemplate, {
              return_id: this.data.orderId,
              reason_parentId: reason.id,
              reason_id: childrenReason.id,
              reason_name: childrenReason.automaticName,
              reason_parentName: childrenReason.parentAutomaticName,
            });
            reasonChildrenLi.dataset.id = childrenReason.id
            reasonChildrenOptionsEl.appendChild(reasonChildrenLi)
          })
        } else {
          reasonChildrenOptionsEl.remove()
          reasonLi.classList.add('no-children')
        }
        fragment.appendChild(reasonLi)
      })
      reasonOptionsEl.appendChild(fragment);
    }
  }
  formatData(){
    this.data.details.forEach(detail => {
      detail.subtotal =( parseFloat(detail.price) * detail.quantity).toFixed(2)
    })
    this.data.total = this.data.details.reduce((prev, current)=> prev + parseFloat(current.subtotal), 0).toFixed(2)
  }
  initCreat(){
    this.orderNumberInit()
    this.logisticsNumberInit(false)
    this.detailsInit(true)
    this.imageInit(true)
    this.notesInit(true)
    this.explainInit(true)
    this.submitWrapperInit(true)
  }
  initTracking(){
    this.orderNumberInit()
    this.logisticsNumberInit(true)
    this.detailsInit(false)
    this.imageInit(false)
    this.notesInit(false)
    this.explainInit(true)
    this.submitWrapperInit(true)
  }
  initStatus(){
    this.orderNumberInit()
    this.logisticsNumberInit(false)
    this.detailsInit(false)
    this.imageInit(false)
    this.notesInit(false)
    this.explainInit(false)
    this.submitWrapperInit(false)
  }
  orderNumberInit(){
    let orderNumber = ''
    if (this.data?.order){
      this.orderNumberEl.innerHTML = `Order Number: #${this.data.order}`
    }
    if (this.data?.requisition){
      this.requisitionNumberEl.innerHTML = `Request Number: ${this.data.requisition}`
    }
  }
  logisticsNumberInit(enable){
    this.logisticsNumberEl.value = this.data?.logistics || ''
    if (enable){
      this.logisticsNumberEl.disabled = false
      this.logisticsBindEvent()
    }else {
      this.logisticsNumberEl.disabled = true
      if (this.type == 1){
        this.logisticsNumberWrapper.classList.add('hide')
      }
    }
  }
  detailsInit(enable) {
    if (this.rowAllRadio){
      this.rowAllRadio.disabled = !enable
      this.rowAllRadio.checked = !enable
    }
    const fragment = document.createDocumentFragment()
    this.data.details.forEach(detail => {
      const detailsDiv = this.creatDivFromTemplate(this.detailListTemplate, detail);
      detailsDiv.dataset.id=detail.id;
      this.detailItemInit(detailsDiv, detail, enable)
      fragment.appendChild(detailsDiv)
    })
    this.detailList.appendChild(fragment);
    this.rowCheckBindEvent()
    this.calcTotal()
  }
  detailItemInit(wrapper, detail, enable) {
    const detailCheck = wrapper.querySelector('.js-detail-check');
    const quantityMinus = wrapper.querySelector('.js-quantity-minus');
    const quantityAdd = wrapper.querySelector('.js-quantity-add');
    const quantityInput = wrapper.querySelector('.js-quantity-input');
    const reasonSelect = wrapper.querySelector('.js-reason-select');
    const reasonOptions = wrapper.querySelector('.js-reason-options');
    if (enable){
      detailCheck.checked = false
      detailCheck.disabled = false
      quantityMinus.disabled = false
      quantityAdd.disabled = false
      quantityInput.disabled = false
      reasonSelect.classList.add('empty')
      if (!detail.notEligible){
        this.quantityBindEvent(wrapper, detail)
        this.reasonBindEvent(wrapper, detail)
      }
    }else{
      detailCheck.checked = true
      detailCheck.disabled = true
      quantityMinus.disabled = true
      quantityAdd.disabled = true
      quantityInput.disabled = true
      reasonSelect.value = detail.returnReasonEn
      reasonSelect.classList.add('disabled')
      reasonSelect.disabled=true
    }
    // 可用性
    if (detail.notEligible){
      this.eligibleFlagBindEvent(wrapper)
      detailCheck.disabled = true
      quantityMinus.disabled = true
      quantityInput.disabled = true
      quantityAdd.disabled = true
      reasonSelect.classList.add('disabled')
      reasonSelect.disabled=true
    }else {
      const detailsEligible = wrapper.querySelector('.js-details-eligible');
      detailsEligible?.remove();
    }
  }
  imageInit(enable){
    if (enable) {
      // 启用
      this.imageUpload.classList.remove('hide');
      this.uploadBindEvent(this.imageWrapper)
    } else {
      // 禁用
      const images = this.data?.images || null;
      if(images?.length){
        this.imageUpload.classList.add('hide')
        const fragment = document.createDocumentFragment()
        images.forEach(image => {
          const imageDiv = this.creatDivFromTemplate(this.imageTemplate, image)
          fragment.appendChild(imageDiv)
        })
        this.imageWrapper.appendChild(fragment);
      } else {
        this.imagesTitleEl.classList.remove('require')
        this.imageUpload.classList.remove('hide')
        const imageUploadInput = this.wrapper.querySelector('.js-image-upload-input');
        imageUploadInput.disabled= true
      }
    }
  }
  notesInit(enable){
    if (enable){
      this.notesEl.value = ''
      this.notesEl.disabled = false
      this.notesLengthEl.classList.remove('hide');
      this.notesBindEvent()
    }else {
      const notesValue = this.data?.notes || ''
      this.notesEl.disabled = true
      this.notesEl.value = notesValue
      if (notesValue.length > 30) {
        this.notesTextEl.innerText = notesValue
        this.notesEl.classList.add('hide')
        this.notesTextEl.classList.remove('hide')
      }
    }
  }
  explainInit(enable){
    if (enable) {
      // 显示
      this.explainEl.classList.remove('hide')
    } else {
      // 隐藏
      this.explainEl.classList.add('hide')
    }
  }
  submitWrapperInit(enable){
    if (enable) {
      // 显示
      this.submitWrapper.classList.remove('hide')
      this.submitBindEvent()
    } else {
      // 隐藏
      this.submitWrapper.classList.add('hide')
    }
  }
  logisticsBindEvent() {
    this.logisticsNumberEl.addEventListener('input',(e) => {
      const value = e.target.value;
      // 清除数字和英文字母以外的字符
      let newValue = value.replace(/[^a-zA-Z0-9]/g, "");
      if (newValue.length >= 50){
        newValue = newValue.slice(0,50)
      }
      this.logisticsNumberEl.value = newValue;
      this.form.logistics = newValue;
      if (/^\d{1,8}$/.test(newValue)  ||
        /^[a-zA-Z]+$/.test(newValue) ||
        /^\d{31,}$/.test(newValue) ||
        /^re/i.test(newValue) ||
        /^mc00/i.test(newValue) ||
        /([a-zA-Z]){4,}/.test(newValue) ||
        this.data.orderNumber == newValue ||
        this.data.orderNo == newValue ||
        this.data.orderNo.replace('-','') == newValue ||
        this.data.logisticsNumber == newValue ||
        this.data.transactionNumber == newValue
      )  {
        this.submitBtn.disabled = true;
        this.logisticsNumbeeErorTipsrEl.classList.remove('hide')
        return
      }else{
        this.logisticsNumbeeErorTipsrEl.classList.add('hide')
      }
      this.checkSubmit()
    })
  }
  eligibleFlagBindEvent(wrapper) {
    const  list =  wrapper.querySelectorAll('.js-eligible-flag');
    list.forEach(eligibleFlag => {
        eligibleFlag.addEventListener('touchstart', (ev)=>{
          ev.preventDefault();
          eligibleFlag.classList.add('touch');
        })
      })
    document.addEventListener('touchend', () => {
      list.forEach(item => item.classList.remove('touch'))
    });
  }
  rowCheckBindEvent() {
    const rowCheckList = this.wrapper.querySelectorAll('.js-detail-check')
    this.rowAllRadio.addEventListener('click', ev => {
      const checked = this.rowAllRadio.checked;
      this.form.details.forEach(detail => {
        detail.checked = checked
      })
      rowCheckList.forEach(rowCheck => {
        if (!rowCheck.disabled) {
          rowCheck.checked = checked
        }
      })
      this.calcTotal()
      this.checkSubmit()
    })
    rowCheckList.forEach(check => {
      check.addEventListener('click', ev => {
        const checked = ev.target.checked;
        const id = ev.target.dataset.id
        const currentDetail = this.form.details.find(detail => detail.id == id)
        currentDetail.checked = checked;
        this.rowAllRadio.checked = this.form.details.every(detail => detail.checked)
        this.calcTotal()
        this.checkSubmit()
      })
    })
  }
  quantityBindEvent(wrapper, detail){
    const quantityOptions = {
      wrapper: wrapper,
      minValue: 1,
      maxValue: detail.quantity
    }
    const quantityInstance = new MicasReturnQuantity(quantityOptions)

    const currentDetail = this.form.details.find(item => item.id == detail.id);
    const subtotalEl = wrapper.querySelector('.js-detail-subtotal')
    quantityInstance.onChange((value) => {
      currentDetail.quantity = value;
      const subtotal = value * detail.price;
      subtotalEl.innerHTML= `$${subtotal.toFixed(2)}`
      this.calcTotal()
    })

  }
  reasonBindEvent(wrapper, detail){
    if (window.matchMedia('(max-width: 768px)').matches){
      this._reasonBindEventMobile(wrapper, detail)
    } else {
      this._reasonBindEvent(wrapper, detail)
    }
  }
  _reasonBindEvent(wrapper, detail){
    const currentDetail = this.form.details.find(item => item.id == detail.id);
    const reasonSelect = wrapper.querySelector('.js-reason-select')
    const reasonSelectOptionList = wrapper.querySelectorAll('.js-reason-options input')
    const reasonParentItems = wrapper.querySelectorAll('.js-reason-options>li')
    const reasonItems = wrapper.querySelectorAll('.js-reason-options li')
    Array.from(reasonItems).forEach(item => {
      item.addEventListener("mouseenter", () => {
        item.classList.add('active')
      });
      item.addEventListener("mouseleave", () => {
        item.classList.remove('active')
      });
    })
    reasonSelect.addEventListener('focus', () => {
      const parentId = currentDetail.parentReason
      const reasonId = currentDetail.reason
      Array.from(reasonItems).forEach(item => {
        item.classList.remove('hide')
        item.classList.remove('active')
        const itemId = item.dataset.id
        if (itemId == reasonId || itemId == parentId){
          item.classList.add('selected')
        } else {
          item.classList.remove('selected')
        }
      })
      reasonSelect.classList.add('options-open')
    })
    reasonSelect.addEventListener('blur', () => {
      // 检查值是否合理, 简单版 直接使用当前值
      setTimeout(() => {
        const reasonInfo = this.reasonFlatList.find(item => item.id == currentDetail.reason)
        const value = reasonInfo?.automaticName || '';
        reasonSelect.value = reasonInfo?.parentAutomaticName ? `${reasonInfo.parentAutomaticName} / ${value}` : value;
      }, 310)
    })
    // 原因框关闭
    document.addEventListener('click', (ev) => {
      const target = ev.target;
      const reasonEl = target.closest('.details-reason');
      const id = reasonEl?.dataset?.id;
      const rowId = reasonSelect.dataset.id;
      if (!reasonEl || id != rowId){
        reasonSelect.classList.remove('options-open')
      }
    })
    reasonSelectOptionList.forEach(optionItem => {
      optionItem.addEventListener('change', (ev) => {
        const target = ev.target
        reasonSelect.value = target.dataset.label;
        reasonSelect.classList.remove('empty')
        currentDetail.reason = target.value
        currentDetail.parentReason = target.dataset.parentId
        reasonSelect.classList.remove('options-open')
        this.checkSubmit()
      })
    })
    //  搜索
    reasonSelect.addEventListener('input', throttle(() => {
      const currentValue = (reasonSelect.value || '').trim().toLowerCase()
      const matchedReasonIds = this.filterReasonIds(currentValue);
      Array.from(reasonItems).forEach(item => {
       const itemId = item.dataset.id
       if (matchedReasonIds.includes(itemId)){
         item.classList.remove('hide')
       } else {
         item.classList.add('hide')
       }
      })
    },300))
  }
  filterReasonIds (value='') {
    return this.reasonFlatList.reduce((acc, item) => {
      if((item.parentAutomaticName.toLowerCase()).includes(value) || (item.automaticName.toLowerCase()).includes(value)){
        acc.push(item.id)
        //保证父级在里面
        if (!acc.includes(item.parentId)){
          acc.push(item.parentId)
        }
      }
      return acc
    }, [])
  }
  _reasonBindEventMobile(wrapper, detail){
    const currentDetail = this.form.details.find(item => item.id == detail.id);
    const reasonSelect = wrapper.querySelector('.js-reason-select')
    reasonSelect.addEventListener('click', () => {
      returnReasonModalInstance.show(currentDetail.reason )
      returnReasonModalInstance.onApply((label,value) => {
        currentDetail.reason = value
        reasonSelect.classList.remove('empty')
        reasonSelect.innerHTML = label
        this.checkSubmit()
      })
    })
  }
  uploadBindEvent(wrapper) {
    const uploadInstance = new MicasReturnImageUpload(wrapper, this.imageTemplate)
    uploadInstance.onChange((value) => {
      this.form.images = value
      this.checkSubmit()
    })
  }
  notesBindEvent() {
    this.notesEl.addEventListener('input',(e) => {
      const value = e.target.value.trim();
      if (value.length > 250){
        const newValue = value.slice(0,250);
        this.notesEl.value = newValue;
        this.form.notes = newValue;
        this.notesLengthEl.innerHTML = '250/250'
      }else {
        this.notesLengthEl.innerHTML = `${value.length}/250`
        this.form.notes = value;
      }
    })
  }
  submitBindEvent(){
    this.cancelBtn.addEventListener('click', () => {
      window.location.href = `${this.starsUrl}`;
    })
    this.submitBtn.addEventListener('click', () => {
      if (this.submitBtn.classList.contains('submit-loading')) {
        return
      }
      if (this.type == 1){
        this.submitCreate()
      } else if (this.type == 2){
        this.submitLogistics()
      }
    })
  }
  submitCreate(){
    const modal = document.querySelector('#shopify_return .js-return-submit-modal')
    const errorModal = document.querySelector('#shopify_return .js-return-submit-error-modal')
    const checkedDetails = this.form.details.filter(detail => detail.checked )
    const imageList = this.form.images.filter(image => !!image?.url);
    const submitData = {
      email: this.form.email,
      number: this.form.number,
      remark: this.form.notes,
      skuList: checkedDetails.map(detail => ({
        orderSkuOriginalId: detail.id,
        quantity: detail.quantity,
        returnReason: detail.reason,
      })),
      urlList: imageList.map(image => image.url),
    }
    this.submitBtn.classList.add('submit-loading')
    fetch(this.submitApi, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(submitData)
    })
      .then(res => res.json())
      .then(res => {
        if (res.code === 200) {
          modal.classList.remove('hide')
          document.documentElement.classList.add('lock-scroll');
        }else{
          errorModal.classList.remove('hide')
          document.documentElement.classList.add('lock-scroll');
        }
      })
      .catch(err => {
        errorModal.classList.remove('hide');
        document.documentElement.classList.add('lock-scroll');
      })
      .finally(() => {
        this.submitBtn.classList.remove('submit-loading')
      })
  }
  submitLogistics(){
    const modal = document.querySelector('#shopify_return .js-return-submit-modal')
    const errorModal = document.querySelector('#shopify_return .js-return-submit-error-modal')
    const submitData = {
      id: this.form.id,
      trackingNumber: this.form.logistics,
    }
    this.submitBtn.classList.add('submit-loading')
    fetch(this.submitLogisticsApi, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(submitData)
    })
      .then(res => res.json())
      .then(res => {
        if (res.code === 200) {
          modal.classList.remove('hide')
          document.documentElement.classList.add('lock-scroll');
        }else{
          errorModal.classList.remove('hide')
          document.documentElement.classList.add('lock-scroll');
        }
      })
      .catch(err => {
        errorModal.classList.remove('hide')
        document.documentElement.classList.add('lock-scroll');
      })
      .finally(() => {
        this.submitBtn.classList.remove('submit-loading')
      })
  }
  calcTotal(){
    const total = this.form.details.reduce((prev, current)=> {
      if (current.checked){
        prev.price =  prev.price + parseFloat(current.price) * current.quantity
        prev.quantity =  prev.quantity + current.quantity
      }
      return prev
    },{price:0, quantity:0})
    this.detailsTotalElList.forEach(detailsTotalEl =>{
      detailsTotalEl.innerHTML=`$${total.price.toFixed(2)}`
    })
    this.detailsQuantityTotalEl.innerHTML = total.quantity
  }
  checkSubmit() {
    let ready = false
    if (this.type == 2){
      ready = !!this.form.logistics
    } else if (this.type == 1){
      const requiredList = []
      // 图片
      // 是否需要图片
      let imageRequire = false;
      this.form.details.forEach(item => {
        if(item.checked && item.reason && this.requireImageReasonList.includes(item.reason)){
          imageRequire = true;
        }
      })
      // 包含上传图片
      requiredList.push(!imageRequire || !!this.form.images?.length);
      if(imageRequire){
        this.imagesTitleEl.classList.add('require')
      }else {
        this.imagesTitleEl.classList.remove('require')
      }
      // SKU列表 选择 与原因
      const checkDetailList = this.form.details.filter(item => item.checked);
      if (!checkDetailList.length) {
        requiredList.push(false);
      }else {
        requiredList.push(checkDetailList.every(item => !!item.reason));
      }
      // 所有的都要满足
      ready = requiredList.every(item => item);
    }
    this.submitBtn.disabled = !ready;
  }
  creatDivFromTemplate(template, data){
    const templateHTML = template.innerHTML;
    let newDiv = document.createElement('div');
    if(Object.prototype.toString.call(data) === '[object Object]'){
      newDiv = template.cloneNode(false);
      newDiv.innerHTML = templateHTML.replace(/#{(\w+)}/g, function(m, key){
        return typeof data[key] === 'undefined' ? m : data[key]
      });
    }else if (typeof data === 'string'){
      newDiv = template.cloneNode(false);
      newDiv.innerHTML = templateHTML.replace(/#{(\w+)}/g, data);
    }
    return newDiv
  }
}
class MicasReturnQuantity {
  constructor( { wrapper, maxValue, minValue }) {
    this.wrapper = wrapper
    this.maxValue = maxValue
    this.minValue = minValue
    this.value = 0
    this.changeCallback = null
    this.init()
  }
  init(){
    this.getEl()
    this.value = this.quantityInput.value * 1
    this.bindEvent()
  }
  getEl(){
    this.minusBtn = this.wrapper.querySelector('.js-quantity-minus')
    this.addBtn = this.wrapper.querySelector('.js-quantity-add')
    this.quantityInput = this.wrapper.querySelector('.js-quantity-input')
  }
  bindEvent() {
    this.initDisable()
    this.addBindEvent()
    this.minusBindEvent()
    this.inputBindEvent()
  }
  initDisable () {
    this.addBtn.disabled = true;
    if (this.value ===1){
      this.minusBtn.disabled = true;
      this.quantityInput.disabled = true;
    }
  }
  addBindEvent(){
    this.addBtn.addEventListener('click', ev => {
      if (this.value >= this.maxValue){return}
      const newValue = this.value + 1
      this.setValue(newValue)
      // 减按钮启用
      this.minusBtn.disabled = false;
      // 如果等于最大值,添加按钮禁用
      this.addBtn.disabled = newValue === this.maxValue;
    })
  }
  minusBindEvent(){
    this.minusBtn.addEventListener('click', ev => {
      if (this.value <=  this.minValue) {return}
      const newValue = this.value - 1
      this.setValue(newValue)
      // 添加按钮启用
      this.addBtn.disabled = false;
      // 如果等于最小值,减少按钮禁用
      this.minusBtn.disabled = newValue === this.minValue;
    })
  }
  inputBindEvent(){
    this.quantityInput.addEventListener('change', ev => {
      let newValue = ev.target.value.trim() * 1;
      if (newValue <= this.minValue){
        newValue = this.minValue
        this.quantityInput.value = this.minValue
      } else if (newValue >= this.maxValue){
        newValue = this.maxValue;
        this.quantityInput.value = this.maxValue
      }
      this.setValue(newValue)
    })
  }
  setValue(newValue) {
    if(newValue !== this.value){
      this.value = newValue
      this.quantityInput.value = newValue
      if (this.changeCallback) {
        this.changeCallback(this.value);
      }
    }
  }
  onChange(changeCallback){
    this.changeCallback = changeCallback
  }
}

class MicasReturnImageUpload {
  constructor( wrapper, imageTemplate ) {
    this.wrapper = wrapper
    this.imageTemplate = imageTemplate
    this.changeCallback = null
    this.getTokenApi = 'https://service.themicas.com/api/sts/get'
    this.sts = null
    this.value = []
    this.init().then()
  }
  async init(){
    this.getEl()
    try {
      this.sts = await this.getStS()
      if (!!OSS){
        this.client = new OSS({
          region: this.sts.region,
          accessKeyId: this.sts.accessKeyId,
          accessKeySecret: this.sts.accessKeySecret,
          stsToken: this.sts.securityToken,
          bucket: this.sts.bucketName,
          refreshSTSToken: async () => {
            const data = await this.getStS();
            return {
              accessKeyId: data?.accessKeyId,
              accessKeySecret: data?.accessKeySecret,
              stsToken: data?.stsToken
            }
          },
          refreshSTSTokenInterval: 3000000,
        });
      } else {
        return console.log('SDK ERR')
      }
    } catch (e) {
      console.log(e)
    }
    this.bindEvent()
  }
  getEl(){
    this.imageUpload = this.wrapper.querySelector('.js-image-upload');
    this.imageUploadInput = this.wrapper.querySelector('.js-image-upload-input');
  }
  getStS() {
    return fetch(this.getTokenApi)
      .then(res => res.json())
      .then(res => {
        if (res.code === 200){
          return res.data
        } else {
          return null
        }
      })
  }
  bindEvent() {
    this.imageUploadInput.addEventListener('change', (ev) => {
      const files = ev.target.files;
      if (files.length){
        const file = files[0]
        const fileName = file.name;
        const fileExtension = fileName.split('.').pop();
        const fileExtensionUpper = fileExtension.toUpperCase();
        if (fileExtensionUpper !== 'JPG' && fileExtensionUpper !== 'JPEG' && fileExtensionUpper !== 'PNG'&& fileExtensionUpper !== 'GIF') {
          return;
        }
        const nameNo = file.lastModified + fileName
        const repeatIndex =  this.value.findIndex(item => item.name === nameNo)
        if (repeatIndex >= 0){
          return
        }else{
          this.value.push({
            name: nameNo,
          })
          if (this.value.length >= 5) {
            this.imageUpload.classList.add('hide')
          }
        }
        const imageDiv = this.creatImageEl();
        const imageEl = imageDiv.querySelector('img')
        this.removeBindEvent(imageDiv, nameNo)
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (e) => {
          imageEl.src=e.target.result
        }
        this.upload(file, imageDiv, nameNo)
      }
    })
  }
  creatImageEl () {
    const templateHTML = this.imageTemplate.innerHTML;
    const imageDiv = this.imageTemplate.cloneNode(false);
    imageDiv.innerHTML = templateHTML.replace(/#{(\w+)}/g, '');
    return imageDiv
  }
  removeBindEvent (imageDiv, nameNo) {
    const imageRemoveBtn = imageDiv.querySelector('.js-image-item-remove')
    imageRemoveBtn.addEventListener('click', ev => {
      const imageIndex = this.value.findIndex(item => item.name === nameNo)
      if (imageIndex >= 0){
        this.value.splice(imageIndex, 1);
      }
      imageDiv.remove()
      if (this.value.length < 5 ){
        this.imageUpload.classList.remove('hide')
      }
      this._onChange()
    })
  }
  upload(file, imageDiv, nameNo){
    imageDiv.classList.add('upload-loading')
    this.wrapper.insertBefore(imageDiv, this.imageUpload)
    if (!!this.sts) {
      this.client.put(nameNo, file)
        .then(res => {
          return this.client.get(nameNo);
        })
        .then(res => {
          const url = res.res.requestUrls[0]
          this.uploadSuccess(imageDiv, nameNo, url)
        })
        .catch(err => {
          console.log(err)
          this.uploadError(imageDiv, nameNo)
        })
    }

  }

  uploadSuccess(imageDiv, nameNo, url) {
    imageDiv.classList.remove('upload-loading')
    imageDiv.classList.add('upload-loaded')
    const imageFormItem = this.value.find(item => item.name === nameNo)
    if (imageFormItem) {
      imageFormItem.url = url
      this._onChange()
    }
  }
  uploadError(imageDiv, nameNo){
    const imageIndex = this.value.findIndex(item => item.name === nameNo)
    if (imageIndex >= 0){
      this.value.splice(imageIndex, 1);
    }
  }
  _onChange() {
    if (this.changeCallback) {
      this.changeCallback(this.value);
    }
  }
  onChange(changeCallback){
    this.changeCallback = changeCallback
  }
}


class MicasReturnReasonModal{
  constructor() {
    this.reasonModal = document.querySelector('.js-return-reason-modal')
    this.reasonModalInner = document.querySelector('.js-return-reason-modal-inner')
    this.reasonApplyBtn = document.querySelector('.js-return-reason-modal-inner .js-return-reason-apply')
    this.getReasonApi = `${returnAPIHost}/oversea/get/config/v2`
    this.applyCallback = null
    this.value = null;
    this.label = 'Select'
    this.init().catch()
  }
  async init() {
    try {
      const reason = await this._getReason()
      if (reason.code === 200){
        this.reasonFlatList = this._formatReason(reason.data);
        this.reasonData = this._arrayToTree(this.reasonFlatList)
        this.render()
        this.bindEvent()
      }else {
        console.log(reason.message)
      }
    } catch (e) {
      console.log(e)
    }
  }
  render() {
    // 插入移动端原因模版
    const reasonOptionsEl = document.querySelector('.return-reason-modal .js-return-reason-options');
    const reasonTemplateEl = document.querySelector('.return-reason-modal .js-template-reason');
    const reasonChildrenTemplateEl = document.querySelector('.return-reason-modal .js-template-reason-children');
    if (reasonTemplateEl){
      const reasonChildrenTemplate = reasonChildrenTemplateEl.cloneNode(true);
      reasonChildrenTemplate.classList.remove('js-template-reason-children');
      reasonChildrenTemplateEl.remove();

      const reasonTemplate = reasonTemplateEl.cloneNode(true);
      reasonTemplate.classList.remove('js-template-reason');
      reasonTemplateEl.remove();

      const fragment = document.createDocumentFragment()
      // 循环原因列表 插入原因项模版
      this.reasonData.forEach(reason => {
        const reasonLi = this.creatDivFromTemplate(reasonTemplate, {
          reason_id: reason.id,
          reason_name: reason.automaticName,
        });
        reasonLi.dataset.id = reason.id
        const reasonChildrenOptionsEl = reasonLi.querySelector('.js-reason-children-options')

        // 如果有二级, 则循环插入二级,同时禁用1级
        if(reason?.children?.length) {
          const reasonOptionInputEl = reasonLi.querySelector('input');
          const reasonOptionCheckDotEl = reasonLi.querySelector('.check-dot');
          reasonOptionInputEl.name = "row_arrow";
          reasonOptionInputEl.type = "checkbox";
          reasonOptionCheckDotEl.classList.replace('check-dot', 'check-arrow');
          reason.children.forEach(childrenReason => {
            const reasonChildrenLi = this.creatDivFromTemplate(reasonChildrenTemplate, {
              reason_parentId: reason.id,
              reason_id: childrenReason.id,
              reason_name: childrenReason.automaticName,
              reason_parentName: childrenReason.parentAutomaticName,
            });
            reasonChildrenLi.dataset.id = childrenReason.id
            reasonChildrenOptionsEl.appendChild(reasonChildrenLi)
          })
        } else {
          reasonChildrenOptionsEl.remove()
          reasonLi.classList.add('no-children')
        }

        fragment.appendChild(reasonLi)
      })
      reasonOptionsEl.appendChild(fragment);
    }
  }
  bindEvent(){
    this.reasonOptionInputList = document.querySelectorAll('.js-return-reason-modal .js-return-reason-options input[name="row_reason"]')
    this.reasonOptionInputArrowList = document.querySelectorAll('.js-return-reason-modal .js-return-reason-options input[name="row_arrow"]')
    this.reasonModal.addEventListener('click', (ev) => {
      const target = ev.target;
      if (target.closest('.js-return-reason-modal-inner') && !target.closest('.js-return-reason-modal-close')){
        return false;
      }else {
        this.hide()
      }
    })
    this.reasonApplyBtn.addEventListener('click', ()=>{
      this.hide()
      if (this.applyCallback){
        const value = this.value
        const label = this.label
        if(value){
          this.applyCallback(label, value)
        }
      }
    })
    this.reasonOptionInputList.forEach(inputItem => {
      inputItem.addEventListener("change", (ev) => {
        this.value = ev.target.value
        this.label =  ev.target.dataset.label
      })
    })
  }
  _getReason() {
    return fetch(this.getReasonApi, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
  }
  _formatReason(data) {
    return data?.map((item) => {
      if (item.parentId === "0") {
        return { ...item, parentAutomaticName: ''}
      }
      const parent = data.find(parent => parent.id === item.parentId) || {};
      return { ...item, parentAutomaticName: parent?.automaticName || ''}
    }) || []
  }
  _arrayToTree(data) {
    return data?.reduce((tree, item) => {
      if (item.parentId === "0") {
        tree.push({ ...item, children: []});
      } else {
        const parent = tree.find(parent => parent.id === item.parentId);
        if (parent) {
          parent.children.push({ ...item});
        }
      }
      return tree;
    }, []) || []
  }
  creatDivFromTemplate(template, data){
    const templateHTML = template.innerHTML;
    let newDiv = document.createElement('div');
    if(Object.prototype.toString.call(data) === '[object Object]'){
      newDiv = template.cloneNode(false);
      newDiv.innerHTML = templateHTML.replace(/#{(\w+)}/g, function(m, key){
        return typeof data[key] === 'undefined' ? m : data[key]
      });
    }else if (typeof data === 'string'){
      newDiv = template.cloneNode(false);
      newDiv.innerHTML = templateHTML.replace(/#{(\w+)}/g, data);
    }
    return newDiv
  }
  show(value){
    this.value = value || null
    let parentId = ''
    this.reasonOptionInputList.forEach(inputItem => {
      inputItem.checked = inputItem.value == value;
      if (inputItem.value == value && inputItem.dataset?.parentId) {
        parentId = inputItem.dataset.parentId
      }
    })
    this.reasonOptionInputArrowList.forEach(inputItem => {
      inputItem.checked = inputItem.value == parentId;
    })
    this.reasonModal.classList.remove('hide')
    setTimeout(() =>{
      this.reasonModalInner.style.bottom = '0'
    })
    document.documentElement.classList.add('lock-scroll');
  }
  hide(){
    this.reasonModal.classList.add('hide')
    this.reasonModalInner.style.bottom = '-600px'
    document.documentElement.classList.remove('lock-scroll');
  }
  onApply(applyCallback){
    this.applyCallback = applyCallback
  }
}
/*
* 创建1
* 物流2
* 查看3
* */
window.addEventListener('DOMContentLoaded', ()=>{
  // 获取页面主容器
  const wrapper =  document.querySelector('#shopify_return');
  const innerWrapper = wrapper.querySelector('.page-main');
  if (wrapper.classList.contains('js-page-return-start')) {
    // 初始化申请页面
    new MicasReturnStars({wrapper:innerWrapper})
  } else if (wrapper.classList.contains('js-page-return-items')) {
    // 初始化详情页面
    // 初始化提交错误弹窗页面
    const modalCloseBtn = document.querySelector('#shopify_return .js-return-submit-modal .js-return-submit-modal-close')
    const modalErrorCloseBtn = document.querySelector('#shopify_return .js-return-submit-error-modal .js-return-submit-modal-close')
    const errorModal = document.querySelector('#shopify_return .js-return-submit-error-modal')
    modalCloseBtn.addEventListener("click", () => {
      window.location.replace("/pages/return_start.html");
    })
    modalErrorCloseBtn.addEventListener("click", () => {
      errorModal.classList.add('hide');
      document.documentElement.classList.remove('lock-scroll');
    })
    // 初始化退货原因组件
    window.returnReasonModalInstance =  new MicasReturnReasonModal()
    // 初始化详情组件
    new MicasReturnItems({wrapper:innerWrapper})
  }
})
